import {FC, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {globalImageManifest, getRouteImages} from '@/data/imageManifest';
import {markImagesAsCritical, preloadImages} from '@/lib/imagePreloader';
import {useNavigation} from '@/context/NavigationContext'

const ImagePreloader: FC = () => {
  const location = useLocation();
  const {pageConfigs, hoveredPage} = useNavigation();

  // Kick off background preloading for all known assets once the app mounts
  useEffect(() => {
    preloadImages(globalImageManifest, 'background');
  }, []);

  // Ensure the current route's hero and navigation assets are priority loaded
  useEffect(() => {
    const criticalAssets = new Set<string>(getRouteImages(location.pathname));
    const currentConfig = pageConfigs[location.pathname];

    if (currentConfig?.image) {
      criticalAssets.add(currentConfig.image);
    }

    if (criticalAssets.size > 0) {
      markImagesAsCritical(Array.from(criticalAssets));
    }
  }, [location.pathname, pageConfigs]);

  // Preload the image for any hovered navigation target to keep interactions snappy
  useEffect(() => {
    if (!hoveredPage?.image) return;
    markImagesAsCritical([hoveredPage.image]);
  }, [hoveredPage?.image]);

  return null;
};

export default ImagePreloader;
